import React, { useEffect, useState } from "react";
import UserTab from './UserTab';
import api from 'api';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { API } from "common/config-api"; // jsconfig.json

const UserRegist = () => {
  const navigate = useNavigate();
  const today = (new Date().getYear() + 1900) + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
  const apiUrl = `${API.BASE_URL}`;

  const {userCode} = useParams();
  console.log("userCode", userCode);

  const [userInfo, setUserInfo] = useState({
    userIdx: 0,
    userCode: "",
    userDate: today,
    userGrade: "bronze",
    userNickname: "",
    userType: "user",
    userArea: "area1",
    userCharacter: "",
    userCharacterBirth: ""
  });

  const submitUser = async () => {
    console.log("userInfo", userInfo);
    try {
      const response = await api.post(apiUrl + '/user', userInfo);
      alert('등록되었습니다.');
      navigate('/user/list');
    } catch (error) {
      console.error('사용자 등록 실패:', error);
      alert('사용자 등록 중 오류가 발생했습니다.');
    }
  };
    
  const onChange = (event) => {
    const { value, name } = event.target; //event.target에서 name과 value만 가져오기
    //console.log('value: ' + value + ', name: ' + [name]);
    setUserInfo({
      ...userInfo,
      [name]: value,
    });
  };

  const getUserInfo = async () => {
    if(userCode){
      try {
        const response = await api.get(apiUrl + '/user/' + userCode);
        const resp = response;
        console.log("resp", resp);
        if(resp.userCharacterBirth === "1900-01-01"){ resp.userCharacterBirth = "" }
        setUserInfo(resp);
      } catch (error) {
        console.error('사용자 정보 조회 실패:', error);
        alert('사용자 정보 조회 중 오류가 발생했습니다.');
      }
    }
  };

  const isDisabled = false;
  useEffect(() => {
    getUserInfo();
  
  }, []);

    return (

        <div className="row">

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">회원정보</h5>

              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">코드</label>
                <div className="col-sm-5">
                <input type="text" className="form-control" name="userCode" onChange={onChange} defaultValue={userCode} />
                </div>
                {/*<label htmlFor="inputText" className="col-sm-4 col-form-label">{userInfo.userCode}</label>*/}
                <div className="col-sm-5">
                  <button type="button" onClick={submitUser} className="btn btn-primary">등록/수정</button>
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">등록일</label>
                <label htmlFor="inputText" className="col-sm-10 col-form-label">{userInfo.userDate}</label>
              </div>

              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">분류</label>
                <div className="col-sm-10">
                  <select className="form-select" name="userType" aria-label="Default select example" onChange={onChange} key={userInfo.userType} defaultValue={userInfo.userType}>
                    <option value="user">회원</option>
                    <option value="dealer">딜러</option>
                    <option value="wholesale">도매</option>
                    <option value="etc">기타</option>
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">등급</label>
                <div className="col-sm-10">
                  <select className="form-select" name="userGrade" aria-label="Default select example" onChange={onChange} key={userInfo.userGrade} defaultValue={userInfo.userGrade}>
                    <option value="iron">iron</option>
                    <option value="bronze">bronze</option>
                    <option value="silver">silver</option>
                    <option value="gold">gold</option>
                    <option value="platinum">platinum</option>
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">닉네임<code>*</code></label>
                <div className="col-sm-10">
                  <input type="text" className="form-control" name="userNickname" onChange={onChange} defaultValue={userInfo.userNickname} />
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">지역<code>*</code> </label>
                <div className="col-sm-10">
                <select className="form-select" name="userArea" aria-label="Default select example" onChange={onChange} defaultValue={userInfo.userArea}>
                    <option value="area1">area1(Osaka)</option>
                    <option value="area2">area2(nearOsaka)</option>
                    <option value="area3">area3(in japan)</option>
                    <option value="area4">area4(Okinawa/Hokkaido)</option>
                    <option value="area5">area5(oversea)</option>
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">트이타</label>
                <div className="col-sm-10">
                  <input type="text" className="form-control" name="userTwitter" onChange={onChange} defaultValue={userInfo.userTwitter} />
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">최애캐</label>
                <div className="col-sm-5">
                  <input type="text" className="form-control" name="userCharacter" onChange={onChange} defaultValue={userInfo.userCharacter} />
                </div>
                <div className="col-sm-5">
                  <input type="date" className="form-control" name="userCharacterBirth" onChange={onChange} defaultValue={userInfo.userCharacterBirth} />
                </div>
              </div>


              {/*<div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label">tag</label>
                <div className="col-sm-4">
                  <input type="text" className="form-control" />
                </div>
                <div className="col-sm-2">
                  <button type="button" className="btn btn-primary">add tag</button>
                </div>
              </div>


              <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2 col-form-label"></label>
                <div className="col-sm-10">

                  <button type="button" className="btn btn-light mb-2">
                    tag11 <span className="badge bg-secondary text-light" onClick={selectDate}>X</span>
                  </button>

                  <button type="button" className="btn btn-light mb-2">
                    tag22 <span className="badge bg-secondary text-light" onClick={selectDate}>X</span>
                  </button>

                  <button type="button" className="btn btn-light mb-2">
                    tag33 <span className="badge bg-secondary text-light" onClick={selectDate}>X</span>
                  </button>

                </div>
              </div>*/}

            </div>
          </div>

          {userInfo.userIdx > 0 ? <UserTab idx={userInfo.userIdx} /> : null}

        </div>

    );

}

export default UserRegist;